import { ISendNotificationParams } from '~/utils/interface/notification';
import axiosClient from './axiosClient';
import { ITransferDistributor } from '~/utils/interface/account';
import { IResponseGetListNotification, IParamsActionLog } from '~/utils/interface/actionLog';

const url: string = '/api/notification';

const notificationApi = {
  getList(params: IParamsActionLog) {
    return axiosClient.get<IResponseGetListNotification>(url, { params });
  },

  send(data: ISendNotificationParams) {
    return axiosClient.post<string>(`/api/notification/due-device`, data);
  },
  transferDistributor(data: ITransferDistributor) {
    return axiosClient.post<string>(url + '/transfer-distributor?username=' + data.username);
  },
};

export default notificationApi;
